import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'scEuroCurrency',
  standalone: true,
})
export class EuroCurrencyPipe implements PipeTransform {
  transform(value: number, decimalSeparator: string = '.'): string {
    const amount = Number(value) || 0;
    const [euros, cents] = amount.toFixed(2).split('.');

    return `€ ${euros}${decimalSeparator}${cents}`;
  }
}
